import React from 'react';
import { Box, Divider, Flex } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import { FormLabel } from 'src/components/Common/FormComponent';

import { useWhyDidYouUpdate } from 'src/utils/hooks';
import { useBoxTargetUserGroups } from '@Policy/hooks';
import { TargetUserGroups } from '@Policy/Components/TargetUserGroups';
import { GeneralPolicyInfo, GeneralStatus } from '@Policy/Filters/General';

export const TargetUserGroupsBox = () => {
  const props = useBoxTargetUserGroups();
  useWhyDidYouUpdate('TeamsTargetUserGroups', {
    ...props,
  });
  return <TargetUserGroups {...props} />;
};

const General = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <GeneralStatus
        skipScanJunkEmailFolderShow={false}
        mipEnableFeatureShow={false}
        rmsEnabledShow={false}
      />
      <Divider mt="22px" mb="22px" />
      <GeneralPolicyInfo />
      <Flex mt="23px" alignItems="flex-start">
        <FormLabel label={t('policy.label.policyTarget')} required />
        <TargetUserGroupsBox />
      </Flex>
    </Box>
  );
};
export default React.memo(General);
